var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8016 14.3125H9V26H12.8016V14.3125Z",
    fill: "#272830"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1568 14.4496C23.1164 14.4368 23.0781 14.423 23.0356 14.4113C22.9846 14.3996 22.9336 14.3901 22.8816 14.3816C22.6797 14.3412 22.4587 14.3125 22.1994 14.3125C19.9831 14.3125 18.5774 15.9243 18.1141 16.5469V14.3125H14.3125V26H18.1141V19.625C18.1141 19.625 20.9871 15.6236 22.1994 18.5625C22.1994 21.1858 22.1994 26 22.1994 26H26V18.1131C26 16.3472 24.7898 14.8756 23.1568 14.4496Z",
    fill: "#272830"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8594 12.7188C11.8863 12.7188 12.7188 11.8863 12.7188 10.8594C12.7188 9.83247 11.8863 9 10.8594 9C9.83247 9 9 9.83247 9 10.8594C9 11.8863 9.83247 12.7188 10.8594 12.7188Z",
    fill: "#272830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.00e5565219465d73d7dfe0f91e881be5.svg";
export { ForwardRef as ReactComponent };